import React, { useState, useEffect, forwardRef, Fragment } from "react";
import {Grid,
        CircularProgress,
        List,
        ListItem,
        ListItemText,
        IconButton,
        Tooltip
} from "@material-ui/core";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import useStyles from './styles';
import ttAPI from '../../api/ttAPI';
import config from '../../config';
import { Link } from '../../components/Wrappers'

const JobHistories = forwardRef((props, ref) => {
    const { closeMenu, onCompleteSuccess } = props;
    const classes = useStyles();
    const [jobId, setJobId] = useState(props.jobId);
    var [data, setData] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedHistoryJobId, setSelectedHistoryJobId] = useState(-1);
    const [selectedHistoryJob, setSelectedHistoryJob] = useState(undefined);
    const [isShowingTagCountDetails, setIsShowingTagCountDetails] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
       let mounted = true;
       const fetchData = async() => {
         const response = await ttAPI.getHistoricalJobs(jobId);
         if(mounted){
            if (response.error !== undefined && response.error !== null) {
              setData(undefined);
            }
            else {
              setData(response);

              if (response !== undefined && response !== null && response.length >= 1) {
                  setSelectedHistoryJobId(response[0].id);
                  setSelectedIndex(0);
              }
            }

         }
       };
       fetchData();

       return () => mounted = false;

    }, [jobId]);

    useEffect(() => {
         let mounted = true;
         const fetchData = async() => {
           const response = await ttAPI.getHistoricalJob(selectedHistoryJobId);
           if(mounted){
               if (response !== null && response !== undefined && response !== '') {
                   setSelectedHistoryJob(response);
               }
               else {
                   setSelectedHistoryJob(null);
               }
               setIsLoading(false);

           }
         };
         setIsLoading(true);
         fetchData();

         return () => mounted = false;

    }, [selectedHistoryJobId]);



    const handleListItemClick = (value, index) => {
        setSelectedIndex(index);
        setSelectedHistoryJobId(value.id);
    };

    const gotoPreviousJob = () => {
        var index = selectedIndex - 1;
        if (index < 0) {
            index = data.length -1;
        }//console.log('gotoPreviousJob',data, index);
        setSelectedIndex(index);
        setSelectedHistoryJobId(data[index].id);
    };

    const gotoNextJob = () => {
        var index = selectedIndex + 1;
        if (index >= data.length) {
            index = 0;
        }
        setSelectedIndex(index);
        setSelectedHistoryJobId(data[index].id);
    };

    const showMoreTagDetails = () => {
        setIsShowingTagCountDetails(true);
    };

    const showLessTagDetails = () => {
        setIsShowingTagCountDetails(false);
    };




  return (data &&
      <div className={classes.contentDiv}>
      <Grid container spacing={4}>
          <Grid item xs={12} md={4} sm={4}>
              <div className={classes.jobListContentTitle}>Past Jobs</div>
              <List className={classes.root} component="nav" aria-label="history jobs" bgcolor={'#fff'}>
                {data.map((value, index) => {
                  return (
                    <Fragment key={value.id}>
                    <ListItem
                      button
                      selected={selectedIndex === index}
                      onClick={(event) => handleListItemClick(value, index)}
                    >
                      <ListItemText>{value.id} {value.job_start}</ListItemText>
                    </ListItem>
                      </Fragment>
                );
              })}
             </List>
          </Grid>

          <Grid item xs={12} md={8} sm={8}>
              {!isLoading && (selectedHistoryJob === null || selectedHistoryJob === undefined) && <div>No data</div>}
              {isLoading && <CircularProgress size={26}/>}
              {!isLoading && selectedHistoryJob && <div>
                <div className={classes.inlineTitle}>
                    <div className={classes.jobContentTitle}>{selectedHistoryJob.name} {selectedHistoryJob.job_id} {selectedHistoryJob.job_start}</div>
                    <div>
                    <IconButton className={classes.jobArrowIcon}
                      color="inherit"
                      onClick={gotoPreviousJob}
                    >
                      <ArrowBackIosIcon/>
                    </IconButton>

                    <IconButton className={classes.jobArrowIcon}
                      color="inherit"
                      onClick={gotoNextJob}
                    >
                      <ArrowForwardIosIcon/>
                    </IconButton>

                    </div>
                </div>

                <div>
                    <div className={classes.job_details_sub_block}>
                        <div className={classes.jobContentTitle}>{selectedHistoryJob.job_start_time} - {selectedHistoryJob.job_finish_time}</div>
                        <div></div>
                    </div>

                    <div className={classes.job_details_sub_block}>
                        <div className={classes.jobContentTitle}>Instructions:</div>
                        <div>{selectedHistoryJob.instructions}</div>
                    </div>

                    <div className={classes.job_details_sub_block}>
                        <div className={classes.jobContentTitle}>Services:</div>
                        <div>{selectedHistoryJob.services}</div>
                    </div>

                    <div className={classes.job_details_sub_block}>
                        <div className={classes.jobContentTitle}>Job card notes:</div>
                        <div>{selectedHistoryJob.jobcard_notes !== undefined && selectedHistoryJob.jobcard_notes !== null && selectedHistoryJob.jobcard_notes.length > 0 &&
                          selectedHistoryJob.jobcard_notes.map((value,index) => {
                            return (
                              <Fragment key={index}>
                                  <div className={classes.inlineTitleContent}>
                                      <div>{value.all_jobcard_notes.worker_name}: </div>
                                      <div>{value.all_jobcard_notes.jobcard_notes === null || value.all_jobcard_notes.jobcard_notes === undefined ? 'N/A' : value.all_jobcard_notes.jobcard_notes}</div>
                                  </div>
                              </Fragment>
                          );
                        })}</div>
                    </div>

                    <div className={classes.job_details_sub_block}>
                        <div className={classes.jobContentTitle}>Timesheet notes:</div>
                        <div>{selectedHistoryJob.timesheet_notes !== undefined && selectedHistoryJob.timesheet_notes !== null && selectedHistoryJob.timesheet_notes.length > 0 &&
                          selectedHistoryJob.timesheet_notes.map((value, index) => {
                            return (
                              <Fragment key={index}>
                                  <div className={classes.inlineTitleContent}>
                                      <div>{value.all_timesheet_notes.worker_name}: </div>
                                      <div>{value.all_timesheet_notes.timesheet_notes === null || value.all_timesheet_notes.timesheet_notes === undefined ? 'N/A' : value.all_timesheet_notes.timesheet_notes}</div>
                                  </div>
                              </Fragment>
                          );
                        })}</div>
                    </div>

                    <div className={classes.job_details_sub_block}>
                        <div className={classes.jobContentTitle}>Hour and Parking: (Total Hours: {selectedHistoryJob.hour}h, Parking: ${selectedHistoryJob.parking})</div>
                        <div>{selectedHistoryJob.job_worker_details !== undefined && selectedHistoryJob.job_worker_details !== null && selectedHistoryJob.job_worker_details.length > 0 &&
                          selectedHistoryJob.job_worker_details.map((value, index) => {
                            return (
                              <Fragment key={index}>
                                  <div className={classes.inlineTitleContent}>
                                      <div>{value.worker_name}: </div>
                                      <div>{value.hour === null || value.hour === undefined ? '0' : value.hour} hours,
                                           ${value.parking === null || value.parking === undefined ? '0' : value.parking}</div>
                                  </div>
                              </Fragment>
                          );
                        })}</div>
                    </div>

                    <div className={classes.job_details_sub_block}>
                        <div className={classes.jobContentTitle}>Tested:</div>
                        <div className={classes.footer}>Note: For TELtag jobs, the TELtag count is included with Electrical tags due to the mixed use of cataloguing-only and electrical description codes.</div>
                        <div className={classes.inlineTagTitleContent}>
                            <div>{selectedHistoryJob.electrical_count} Electrical,&nbsp;
                            {selectedHistoryJob.fire_count} Fire,&nbsp;
                            {selectedHistoryJob.first_aid_count} First Aid,&nbsp;
                            {selectedHistoryJob.medical_count} Medical,&nbsp;
                            {selectedHistoryJob.ladder_count} Ladder,&nbsp;
                            {selectedHistoryJob.aed_count} AED,&nbsp;
                            {selectedHistoryJob.evse_count} EVSE,&nbsp;
                            {selectedHistoryJob.other_count} Other,&nbsp;
                            {selectedHistoryJob.total_repairs} Repairs,&nbsp;
                            {selectedHistoryJob.travel_count} Travel&nbsp;
                            {selectedHistoryJob.job_id && <Link href={`${config.clientApi}/reports/job/assets?id=${selectedHistoryJob.job_id}`} target="_blank" underline="none" color="#536DFE">
                            Download
                            </Link>}

                            </div>
                            <div>
                                  {!isShowingTagCountDetails && <Tooltip title="Show more tag info" aria-label="expand"><IconButton className={classes.jobArrowIcon}
                                    color="inherit"
                                    onClick={showMoreTagDetails}
                                  ><ExpandMoreIcon/></IconButton></Tooltip>}
                                  {isShowingTagCountDetails && <Tooltip title="Show less tag info" aria-label="less"><IconButton className={classes.jobArrowIcon}
                                    color="inherit"
                                    onClick={showLessTagDetails}
                                  ><ExpandLessIcon/></IconButton></Tooltip>}
                            </div>
                      </div>
                      <div className={classes.inlineTitleContent}>

                            {isShowingTagCountDetails && <><div>1 Phase:</div><div>{selectedHistoryJob.one_phase_count}</div>
                            <div>3 Phase:</div><div>{selectedHistoryJob.three_phase_count}</div>
                            <div>3 Phase RCD:</div><div>{selectedHistoryJob.three_phase_rcd_count}</div>
                            <div>LG M:</div><div>{selectedHistoryJob.lg_m_count}</div>
                            <div>LG PB:</div><div>{selectedHistoryJob.lg_pb_count}</div>
                            <div>RCD M:</div><div>{selectedHistoryJob.rcd_m_count}</div>
                            <div>RCD PB:</div><div>{selectedHistoryJob.rcd_pb_count}</div>
                            <div>Microwave:</div><div>{selectedHistoryJob.microwave_count}</div>
                            <div>Microwave Leakage:</div><div>{selectedHistoryJob.microwave_leakage_count}</div>
                            <div>Fire:</div><div>{selectedHistoryJob.fire_count}</div>
                            <div>First Aid:</div><div>{selectedHistoryJob.first_aid_count}</div>
                            <div>Medical:</div><div>{selectedHistoryJob.medical_count}</div>
                            <div>Ladder:</div><div>{selectedHistoryJob.ladder_count}</div>
                            <div>AED:</div><div>{selectedHistoryJob.aed_count}</div>
                            <div>EVSE:</div><div>{selectedHistoryJob.evse_count}</div>
                            <div>Other:</div><div>{selectedHistoryJob.other_count}</div>
                            <div>Repairs:</div><div>{selectedHistoryJob.total_repairs}</div>
                            <div>Travel:</div><div>{selectedHistoryJob.travel_count}</div></>}
                        </div>
                    </div>

                    <div className={classes.inlineTitleContent}>
                          <div className={classes.jobContentTitle}>Leader:</div><div>{selectedHistoryJob.leader === undefined || selectedHistoryJob.leader === null ? (selectedHistoryJob.workers !== undefined && selectedHistoryJob.workers !== null && selectedHistoryJob.workers.length === 1 ? selectedHistoryJob.workers[0]: 'N/A') : 'N/A' }</div>

                          <div className={classes.jobContentTitle}>Workers:</div><div>{selectedHistoryJob.workers === undefined || selectedHistoryJob.workers === null ? 'N/A' : selectedHistoryJob.workers.map((value) => {
                                                  return (
                                                    <Fragment key={value}>
                                                        <div>{value}</div>
                                                    </Fragment>
                                                  );
                                                })}</div>
                          <div className={classes.jobContentTitle}>PO:</div><div>{selectedHistoryJob.code !== undefined && selectedHistoryJob.code !== null && selectedHistoryJob.code !== 'null' ? selectedHistoryJob.code : ''}</div>
                          <div className={classes.jobContentTitle}>contact:</div><div>{selectedHistoryJob.contact}</div>
                    </div>
                </div>
              </div>}
          </Grid>
      </Grid>
      </div>);
});
export default JobHistories;
